/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Navigate,
    Route, Routes,
} from 'react-router-dom';
import InputsContainer from './InputsContainer';
import CreateInputContainer from './CreateInputContainer';
import EditInPutContainer from './EditInputContainer'
import InvalidateInputContainer from "./InvalidateInputContainer";


export default class InputsRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/" element={<InputsContainer/>} />
                <Route path="/create-input" element={<CreateInputContainer/>} />
                <Route path="/:id/edit-input" element={<EditInPutContainer/>} />
                <Route path="/:id/invalidate-input" element={<InvalidateInputContainer/>} />
            </Routes>
        );
    }
}
